import { StatusTag, type StatusTagProps } from '@pie/amber';
import { getCuratedStatus, type IssuedPolicy } from '@/hooks/usePolicy';
import { IconCalendarClock, IconCalendarX, IconShieldCheck, IconShieldOff } from '@pie/amber-icons';

type Presets = 'children' | 'emphasis' | 'icon' | 'tone';

interface PolicyLifecycleStatusTagProps extends Omit<StatusTagProps, Presets> {
  policy: Pick<IssuedPolicy, 'effectiveDate' | 'lifecycleStatus'>;
}

export const PolicyLifecycleStatusTag = ({ policy, ...props }: PolicyLifecycleStatusTagProps) => {
  const curatedStatus = getCuratedStatus(policy);

  switch (curatedStatus) {
    case 'active':
      return (
        <StatusTag {...props} emphasis="heavy" icon={<IconShieldCheck />} tone="positive">
          Active
        </StatusTag>
      );
    case 'cancelled':
      return (
        <StatusTag {...props} emphasis="heavy" icon={<IconShieldOff />} tone="negative">
          Canceled
        </StatusTag>
      );
    case 'expired':
      return (
        <StatusTag {...props} emphasis="heavy" icon={<IconCalendarX />} tone="neutral">
          Expired
        </StatusTag>
      );
    case 'pending':
      return (
        <StatusTag {...props} emphasis="heavy" icon={<IconCalendarClock />} tone="systematic">
          Pending
        </StatusTag>
      );
    default:
      // TODO: report to Datadog
      return null;
  }
};
